/**
 * Parse progress-export CSV text into { headers, rows }.
 * RFC 4180–aware: newlines and "" inside quoted fields are preserved.
 *
 * @param {string} text
 * @returns {{ headers: string[], rows: string[][] }}
 */
export function parseProgressExportCsv(text) {
    if (!text || typeof text !== 'string') return { headers: [], rows: [] };

    // Match previous preview behavior: ignore trailing blank lines / whitespace.
    const src = text.trimEnd();
    if (!src) return { headers: [], rows: [] };

    const rows = [];
    let row = [];
    let field = '';
    let inQuotes = false;

    function pushField() {
        row.push(field);
        field = '';
    }

    function pushRow() {
        if (row.some((cell) => String(cell).trim() !== '')) {
            rows.push(row);
        }
        row = [];
    }

    for (let i = 0; i < src.length; i++) {
        const c = src[i];

        if (inQuotes) {
            if (c === '"') {
                if (src[i + 1] === '"') {
                    field += '"';
                    i += 1;
                } else {
                    inQuotes = false;
                }
            } else {
                field += c;
            }
            continue;
        }

        if (c === '"') {
            inQuotes = true;
            continue;
        }

        if (c === ',') {
            pushField();
            continue;
        }

        if (c === '\r' || c === '\n') {
            if (c === '\r' && src[i + 1] === '\n') {
                i += 1;
            }
            pushField();
            pushRow();
            continue;
        }

        field += c;
    }

    // Trailing field/row (no final newline), or leftover after last line.
    if (field.length > 0 || row.length > 0 || inQuotes) {
        pushField();
        pushRow();
    }

    // Match prior trimEnd behavior: ignore a trailing blank line already skipped by pushRow.
    const headers = rows[0] || [];
    return { headers, rows: rows.slice(1) };
}
